export enum BulkPendInputType {
  PendId = 1,
  ChaseId = 2,
}
